export const PUSH_NOTIFICATIONS_KEY = 'push-notifications';
export const PUSH_NOTIFICATIONS_DEVICES_KEY = 'push-notifications-devices';
